import { JOURNEY_HOME_COPY as C } from "./copy";

/**
 * Pure helpers for the conversational Daily Check-In (guide §5.1b).
 */

/**
 * Where the conversation runs once `/checkin/start` hands back a session.
 * Text rides the ordinary Talk thread and voice the ordinary private session;
 * both carry the id so the server attaches the check-in brief.
 */
export const checkInDestination = (sessionId, mode) => {
  if (!sessionId) return null;
  const id = encodeURIComponent(sessionId);
  return mode === "voice"
    ? `/coach/private?checkin_session_id=${id}`
    : `/chat?checkinSessionId=${id}`;
};

/** "Voice / Speak with Aris" → ["Voice", "Speak with Aris"]. */
const splitLabel = (value) => {
  if (typeof value !== "string" || !value.trim()) return [];
  const [label, ...hint] = value.split(" / ");
  return [label.trim(), hint.join(" / ").trim() || undefined];
};

/**
 * The sheet's copy. AVAILABLE carries its four strings on
 * `action.sheet` (WP-10a); anything missing falls back to the App. D
 * defaults, which the Explore sheet already uses for the option labels.
 */
export const checkInSheetCopy = (checkIn) => {
  const sheet = checkIn?.action?.sheet || {};
  const [voice, voiceHint] = splitLabel(sheet.voice_label);
  const [text, textHint] = splitLabel(sheet.text_label);
  const labels = {};
  if (voice) labels.voice = voice;
  if (voiceHint) labels.voiceHint = voiceHint;
  if (text) labels.text = text;
  if (textHint) labels.textHint = textHint;
  return {
    title: sheet.header || C.checkIn.title,
    subtitle: sheet.subheader || C.checkIn.subtitle,
    labels,
  };
};

/**
 * The card once today is done. `completion.copy` (from a COMPLETED /start)
 * carries the server's resolved strings; without it the card shows completed
 * with no button until the refetch lands. Nothing is composed client-side.
 */
export const completedCheckIn = (current, completion) => {
  const copy = completion?.copy || {};
  return {
    ...(current || {}),
    state: "COMPLETED",
    checked_in_today: true,
    action: null,
    ...(copy.status ? { status: copy.status } : {}),
    ...(copy.timestamp ? { timestamp: copy.timestamp } : {}),
    ...(copy.message ? { message: copy.message } : {}),
  };
};
